import React from 'react';
import QRGenerator from './QRGenerator';

export default function MenuQR() {
  return (
    <div className="flex flex-col gap-12 w-full max-w-4xl mx-auto font-sans">
      <section className="text-center max-w-2xl mx-auto flex flex-col gap-4 py-4">
        <span className="self-center px-3 py-1 rounded-full bg-indigo-600/10 text-indigo-400 border border-indigo-500/20 text-xs font-semibold uppercase tracking-wider">
          Digital PDF Menus
        </span>
        <h1 className="text-4xl md:text-5xl font-black tracking-tight leading-tight bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
          Free Restaurant Menu QR Code Creator
        </h1>
        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
          Create premium contactless QR codes for your dining establishment's PDF menus. Direct redirects, zero intermediate ads, and completely free of watermarks or scan limits.
        </p>
      </section>

      <section className="w-full">
        <QRGenerator defaultTab="url" hideTabs={true} />
      </section>

      <section className="border-t border-gray-900 pt-10 flex flex-col gap-6 max-w-3xl mx-auto text-left">
        <div className="flex flex-col gap-3 bg-gray-900/20 border border-gray-900 rounded-2xl p-6">
          <h3 className="text-lg font-bold text-gray-200">How-To Steps:</h3>
          <ol className="flex flex-col gap-3 text-sm text-gray-400 list-decimal list-inside">
            <li>
              <strong className="text-gray-300">Paste Menu PDF Link:</strong> Upload your PDF to a cloud drive and paste its public link above.
            </li>
            <li>
              <strong className="text-gray-300">Add Restaurant Logo:</strong> Overlay your center brand identity icon onto the code design.
            </li>
            <li>
              <strong className="text-gray-300">Download:</strong> Instantly export vector SVG or PNG print-ready restaurant templates.
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-4 text-sm text-gray-400 leading-relaxed">
          <h2 className="text-lg font-bold text-gray-200">Contactless Dining Benefits</h2>
          <p>
            Providing a digital menu reduces physical print costs, keeps dining tables neat, and allows you to update your dishes instantly without re-printing physical materials.
          </p>
          <p>
            For a premium brand aesthetic, utilize our design panel to upload your restaurant's brand logo, apply harmonious colors, and export high-quality SVG files that print perfectly on physical menus, table tents, and entryway posters.
          </p>
        </div>
      </section>
    </div>
  );
}
